import { APIGet, APIPost, APIUrl, AdminType } from "api/protocols";

export interface IPaymentMethodRequestInfo {
  customer: {
    first_name: string;
    full_name: string;
    email: string;
    phone: string;
    state: string;
  };
  facility: {
    id: number;
    long_name: string;
    logo_source: string | null;
    country_code: string;
  };
  client: {
    id: number;
    long_name: string;
    short_name: string;
  };
  expires_at: string;
}

export async function GetPaymentMethodRequest(params: { token: string }, useGlobalLoader?: boolean) {
  return await APIGet(APIUrl(AdminType.Guest, "/customer/payment-method/request"), params, useGlobalLoader);
}

export async function PostGuestPaymentMethodSetup(params: { token: string }, useGlobalLoader?: boolean) {
  return await APIPost(APIUrl(AdminType.Guest, "/customer/payment-method/setup"), params, useGlobalLoader);
}

export async function PostGuestPaymentMethod(
  params: { token: string; payment_method_id: string; save_card?: boolean; save_on_profile?: boolean },
  useGlobalLoader?: boolean,
) {
  return await APIPost(APIUrl(AdminType.Guest, "/customer/payment-method"), params, useGlobalLoader);
}
